import { Button, ButtonProps } from '@mui/material';
import { styled } from '@mui/material/styles';
import React from 'react';
import Text from '../../components/Text';
import Colors from '../../layout/theme/utils/colors';

const StyledButtonRoot = styled(Button)(({ theme }) => ({
  height: 36,
  borderRadius: 100,
  backgroundColor: Colors.sky_blue,
  color: Colors.navy,
  border: `1px solid ${Colors.sky_blue}`,
  boxShadow: 'none',
  padding: theme.spacing(0.625, 2.5),

  '&:hover': {
    backgroundColor: Colors.sky_blue,
  },

  '&.Mui-disabled': {
    opacity: 0.8,
    pointerEvents: 'none',
  },
}));

interface StyledCancelFBButtonProps extends ButtonProps {
  label: string
  dataCy?: string
}

const StyledCancelFBButton: React.FC<StyledCancelFBButtonProps> = ({
  label,
  ...props
}) => (
  <StyledButtonRoot {...props} data-cy={props['data-cy'] || 'common.cancel'}>
    <Text message={label} />
  </StyledButtonRoot>
);

export default StyledCancelFBButton;
